import locationZoneAllComponent from './location_zone.all.component';

let locationZoneAllModule = angular.module('locationZoneAll', [])

    .component('locationZoneAll', locationZoneAllComponent)

    .name;

export default locationZoneAllModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/location_zone/all/index.js